import Popover from 'bootstrap/js/dist/popover';
import { OffCanvasComponent } from './offcanvas';
import { showModalAjax } from '../design_system/components/modal';
import { bpHelper } from './utils';
import { popupLinkConfig } from '../config/popup-link';

export class PopUpLink {
  #popOver;
  #offCanvas;
  #activeClass = 'display-content--active';
  $link;

  constructor() {
    this.#initElements();
  }

  setAttributes() {
    this.title = this.$link.data('title');
    this.body = this.$link.data('body');
    this.customClass = this.$link.data('popover-class') || '';
    this.tooltipClass = ('tooltip-element' + ' ' + this.customClass).trim();
    this.forcePopupPosition = this.$link.data('force-popup-position');
    this.positionPopup = this.forcePopupPosition || this.$link.data('position-popup');
    this.container = this.$link.data('container') || false;
    this.positionCanvas = this.$link.data('position-canvas');
    this.computerDisplay = this.$link.data('computer-display');
    this.mobileDisplay = this.$link.data('mobile-display');
    this.modalContent = this.$link.data('modal-content');
    this.modalRefresh = this.$link.data('modal-refresh');
    this.modalId = this.$link.data('modal-id');
  }

  #initElements() {
    const self = this;

    document.arrive('.display-content', function(element) {
      $(element).on('click', function() {
        self.$link = $(this);
        self.setAttributes();

        if (self.$link.hasClass(self.#activeClass)) {
          const openedPopover = Popover.getInstance(this);
          openedPopover.hide();
          self.$link.removeClass(self.#activeClass);
          return false;
        }

        if ((bpHelper.isMatching('md', true) && self.mobileDisplay === 'canvas') ||
            self.computerDisplay === 'canvas') {
          self.showOffCanvas();
        } else if ((bpHelper.isMatching('md', true) && self.mobileDisplay === 'popover') ||
            (!bpHelper.isMatching('md', true) && self.computerDisplay === 'popover')) {
          self.showPopOver();
        } else if ((bpHelper.isMatching('md', true) && self.mobileDisplay === 'modal') ||
            (!bpHelper.isMatching('md', true) && self.computerDisplay === 'modal')) {
          // ici créer et afficher une modale avec le même contenu que le popover ou le canvas

          showModalAjax(self.modalContent, self.modalId, self.modalRefresh);
        }
      });
    });
  }

  createPopOver() {
    this.#popOver = Popover.getOrCreateInstance(this.$link,
      {
        title: this.title || '',
        container: this.container,
        content: this.body,
        placement: this.positionPopup || 'left',
        fallbackPlacements: (this.forcePopupPosition ? [this.forcePopupPosition] : ['top', 'right', 'bottom', 'left']),
        html: true,
        trigger: 'manual',
        sanitize: false,
        customClass: this.tooltipClass,
        popperConfig: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
                padding: 12,
              },
            },
            {
              name: 'flip',
              options: {
                boundary: 'viewport',
                fallbackPlacements: (this.forcePopupPosition ? [this.forcePopupPosition] : ['top', 'right', 'bottom']),
                allowedAutoPlacements: ['left', 'right', 'top', 'bottom'],
                padding: 12,
              },
            },
          ],
        },
      }
    );
  }

  showPopOver() {
    this.createPopOver();
    this.addPopOverEvents();
    this.#popOver.show();
  }

  addPopOverEvents() {
    this.#popOver._element.addEventListener('hide.bs.popover', () => {
      this.$link.removeClass(this.#activeClass);
      $(document).off('mouseup', (e) => this.documentMouseUp(e));
    }, { once: true });

    $(`.${popupLinkConfig.closeBtnClass}`).click(() => {
      this.#popOver.hide();
    });

    $(document).one('mouseup', (e) => this.documentMouseUp(e));
  }

  documentMouseUp(e) {
    const $container = $(`.${this.tooltipClass.replaceAll(' ', '.')}`);

    // if the target of the click isn't the container nor a descendant of the container
    // and it is nor the element that we clicked that is targeted
    const clickOnModal = e.target.classList.contains('modal') || e.target.classList.contains('modal-backdrop');
    // const isInPopover = !!e.target.closest('.popover');

    if (
      !clickOnModal &&
        !$container.is(e.target) &&
        $container.has(e.target).length === 0 &&
        !this.$link.is(e.target) &&
        this.$link.has(e.target).length === 0 &&
        !$(e.target).closest('.accordion--border').length
    ) {
      this.#popOver.hide();
    } else {
      $(document).one('mouseup', (e) => this.documentMouseUp(e));
    }
  }

  createOffCanvas() {
    this.#offCanvas = new OffCanvasComponent(
      this.title,
      this.body,
      this.positionCanvas,
      this.customClass
    );
  }

  showOffCanvas() {
    this.createOffCanvas();
    this.adjustOffCanvasZIndex();
    this.#offCanvas.show();
  }

  adjustOffCanvasZIndex() {
    const $parent = this.$link.parents('.modal.show').first();
    if ($parent.length > 0) {
      $(this.#offCanvas.offcanvas._element).css('z-index', $parent.css('z-index') * 1 + 2);
      $(this.#offCanvas.offcanvas._backdrop._element).css('z-index', $parent.css('z-index') * 1 + 1);
    } else {
      $(this.#offCanvas.offcanvas._element).css('z-index', '');
      $(this.#offCanvas.offcanvas._backdrop._element).css('z-index', '');
    }
  }
}
